<template>
    <div class="ContactUs">
        <menuBox :step="4"></menuBox>
        <div class="skit-box">
            <div class="text-box">
                <div>Contact Us</div>
                <p>We look forward to talking to you and are always ready to support and assist you no matter what questions you have.</p>
            </div>
        </div>
        <div class="contact-box">
            <div class="contact-us">
                <div class="us-title">Contact information </div>
                <div class="tel-box">
                    <div>E-mail: </div>
                    <p>linn@creative-wonderful.com</p>
                </div>
                <div class="tel-box">
                    <div>Address:</div>
                    <p>Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates</p>
                </div>
            </div>
            <div class="contact-text">
                <br><strong>Contact us anytime</strong>
                <br>Whether you want to know more about our company, or have any cooperation intentions or suggestions, we are very happy to communicate with you.

                <br>Customer service
                <br>If you have any questions or need help, our customer service team is here to help.

                <br>Cooperation and business
                <br>If you have any cooperation intentions or business cooperation suggestions, our business team will serve you wholeheartedly.

                <br>Feedback
                <br>We attach great importance to your opinions and suggestions to help us continuously improve and enhance the quality of our services. If you have any comments or suggestions, please contact us

                <br>We look forward to hearing from you and thank you for your support and interest in us!
            </div>
        </div>

        <div class="submit-box">
            <div class="title">Please feel free to contact us. If you know more information, please leave your contact information.</div>
            <div class="seng-box">
                <input type="text" v-model="value" class="input-text" placeholder="Your email address">
                <div class="btn-sub" @click="SubmitOk">Submit</div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            value: ''
        }
    },
    mounted() {

    },
    methods: {
        SubmitOk() {
            if (!this.value) {
                return alert('please enter your email')
            }
            alert('Submitted successfully')
        }
    }
}
</script>
<style lang="less" scoped>
.skit-box {
    height: 458px;
    background: url(../assets/img_8.png);
    background-size: 100% 100%;

    .text-box {
        width: 450px;
        margin-left: 360px;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        height: 100%;

        div {
            font-weight: bold;
            font-size: 60px;
            color: #FFFFFF;
        }

        p {
            font-weight: 500;
            font-size: 18px;
            color: #B9B9B9;
            margin-top: 20px;
        }
    }
}

.contact-box {
    padding: 150px 360px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .contact-us {
        width: 360px;
        margin-right: 28px;
        background: #F4F4F4;
        padding-bottom: 58px;

        .us-title {
            width: 360px;
            height: 80px;
            background: #FF015A;
            line-height: 80px;
            font-weight: 600;
            font-size: 25px;
            color: #FFFFFF;
            text-align: center;
        }

        .tel-box {
            padding: 0px 37px;
            margin-top: 15px;

            .tel-box {
                div {
                    font-weight: 600;
                    font-size: 18px;
                    color: #37393F;
                }

                p {
                    font-weight: 400;
                    font-size: 18px;
                    color: #7D7D7D;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #333;
                }
            }
        }
    }

    .contact-text {
        line-height: 1.5em;
        font-weight: 400;
        font-size: 18px;
        color: #7D7D7D;
    }
}

.submit-box {
    margin: 0px 360px 150px 360px;
    background: #F4F4F4;
    min-height: 308px;
    padding: 0px 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        width: 400px;
    }

    .seng-box {
        display: flex;
        // width: 800px;

        .input-text {
            width: 250px;
            height: 68px;
            background: #FFFFFF;
            border-radius: 54px 54px 54px 54px;
            border: 1px solid #E3E3E3;
            padding: 0px 28px;
        }

        .btn-sub {
            width: 168px;
            height: 59px;
            background: #FF015A;
            border-radius: 42px 42px 42px 42px;
            font-weight: 600;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 59px;
            text-align: center;
            margin-left: 28px;

        }
    }
}
</style>
